// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__1IIpY"};